import * as React from 'react';
import { cn } from '../lib/utils';

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'border-border bg-surface-raised text-foreground placeholder:text-muted-foreground focus:border-ring focus:ring-ring disabled:bg-muted box-border flex h-[var(--crm-control-height)] min-h-[var(--crm-control-height)] max-h-[var(--crm-control-height)] w-full rounded-[var(--crm-control-radius)] border px-3 py-1.5 text-[13px] leading-normal focus:ring-1 focus:outline-none disabled:cursor-not-allowed disabled:opacity-50',
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = 'Input';

export { Input };
